import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';

import { cn } from '@lib/utils';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = (props: React.ComponentProps<typeof AccordionPrimitive.Item>) => {
  const { className, ...otherProps } = props;

  return (
    <AccordionPrimitive.Item
      className={cn('border-b', className)}
      {...otherProps}
    />
  );
};
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = (props: React.ComponentProps<typeof AccordionPrimitive.Trigger>) => {
  const { children, className, ...otherProps } = props;

  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          'flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180',
          className,
        )}
        {...otherProps}
      >
        {children}
        <ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
};
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = (props: React.ComponentProps<typeof AccordionPrimitive.Content>) => {
  const { children, className, ...otherProps } = props;

  return (
    <AccordionPrimitive.Content
      className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      {...otherProps}
    >
      <div className={cn('pb-4 pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
};

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
